/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from "react";

import chatIcon from "../../../assets/icons/chat.svg";

import * as Styles from './ZendeskButtonStyles';

const ZendeskButton: React.FC = () => {
  const { openBotpressChat } = window;  
  return (
    <Styles.ZendeskButton type="button" onClick={() => openBotpressChat()}>
      <img src={chatIcon} alt="Chat" />
    </Styles.ZendeskButton>
  )
}

export default ZendeskButton;
